import React, { FC } from 'react';

import Styled from './style';
import useHook from './hook';
import AppButton from '../../shared/app-button';
import { AuthWrapper } from '../../shared/auth-wrapper';
import { Typography } from '../../shared/typography';

type IProps = {};

const AwaitingApprovePage: FC<IProps> = () => {
	const { isLoading, checkStatus } = useHook();

	return (
		<AuthWrapper>
			<Styled.Bottom>
				<Styled.Content>
					<div style={{ width: '100%' }}>
						<Styled.Center>
							<Typography
								style={{ textAlign: 'center', marginBottom: 20 }}
								size="large"
							>
								We are now waiting for your Revvy account admin to approve your
								access request.
							</Typography>
							<Typography style={{ textAlign: 'center' }} size="large">
								Once approved, you will receive an email with a link to access
								your company's say/it account without the need to have a
								salesforce licence
							</Typography>
						</Styled.Center>
						<AppButton
							style={{ maxWidth: 475, marginTop: 0 }}
							title="I understand"
							color="lightGrey"
							titleColor="black"
							borderWidth={1}
							loaderColor="blue"
							type="bold"
							isBorder
							callBack={checkStatus}
							isLoading={isLoading}
						/>
					</div>
				</Styled.Content>
			</Styled.Bottom>
		</AuthWrapper>
	);
};

export default AwaitingApprovePage;
